export const FUNDING_ENGINE_VERSION="company-funding-v3-gc-source";
/** Stable snapshot encoding; presentation order cannot change a source fingerprint. */
export function canonicalFundingJson(value:unknown):string{
  return JSON.stringify(value,(_key,item:unknown)=>{
    if(item instanceof Map)return [...item.entries()].sort(([a],[b])=>String(a).localeCompare(String(b)));
    if(item&&typeof item==="object"&&!Array.isArray(item))return Object.fromEntries(Object.entries(item).sort(([a],[b])=>a.localeCompare(b)));
    return item;
  });
}
export async function fundingFingerprint(value:unknown):Promise<string>{
  const digest=await crypto.subtle.digest("SHA-256",new TextEncoder().encode(canonicalFundingJson(value)));
  return [...new Uint8Array(digest)].map(byte=>byte.toString(16).padStart(2,"0")).join("");
}
